<template>
  <modal name="carModelNameSrchPopup" :width="850" :height="500" :clickToClose="false" @before-open="beforeOpen" @opened="opened">
    <div id="div_carModelNameSrch" class="popup on">
      <div class="pop_tit">
        차량모델 검색
      </div>
      <div id="div_carModelNameSrchPopupScroll" class="scroll_area pop_con_wrap" style="height:350px;">
        <div class="tab_radio_wrap">
          <div class="tab_radio">
            <div class="custom-radio-02">
              <input type="radio" id="ctab01" name="tabs1" class="radio" checked="checked" @click="selectTabCode({'ifCondition':'carId'})">
              <label for="ctab01">차량번호</label>
            </div>
            <div class="custom-radio-02">
              <input type="radio" id="ctab02" name="tabs1" class="radio" @click="selectTabCode({'ifCondition':'vehicleId'})">
              <label for="ctab02">차대번호</label>
            </div>
          </div>
        </div>
          <div class="pop_search_bg bgf7 mt20">
            <div class="input-group-02">
              <div class="colum-02 ">
                <div class="form_box-02">
                  <input type="text" id="code" class="input-text" placeholder="" value="" autocomplete="off"
                      v-model.lazy.trim="grid_options.general.params.commonParam">
                </div>
              </div>
              <div class="colum-02 col-1">
                <div class="form_group">
                  <a href="javascript:void(0);" class="account_btn-02" @click="searchCarModelName">조회</a>
                </div>
              </div>
            </div>
          </div>
          <div class="model_text">
            <span>차량상세 모델결과</span>
            <p>
              {{this.carName}}
            </p>
          </div>
      </div>
      <div class="pop_footer_wrap">
        <div class="btn_area mt0">
          <a href="javascript:void(0);" class="button blue" @click="sendCarModelName"><span>선택</span></a>
        </div>
      </div>
      <a href="javascript:void(0);" class="pop_close" title="close" @click="close">close</a>
    </div>
  </modal>
</template>

<script>
import Grid from '@/components/Grid'
import GridModule from '@/modules/grid'
import Vue from 'vue'

export default {
  name : 'carModelNameSrchPopup',
  components : { Grid, GridModule, Vue },
  props : {
    value : '',
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      //pushToParent: '',
      selectedTab: '',
      selectedCode: '',
      carName : '',
      grid_options : {
        general : {
          id  : 'car-model-name-popup-grid',
          search : '',
          excel : false,    
          type : {
            isUpdate : false,
            //isHideAdd : true : true,
          },
          params : {
            commonParam: '',
            ifCondition: ''
          }
        }//,
        // grid_options : {
      //     height: 240,
      //     autoColumnIndex: true,
  //     // rowindexColumnFromZero: false,
      //     rowSelectOption:{
    //         clickSelect: true,
    //         singleSelect: true,
    //         radioColumn: true,
    //         allowSingleUnselect: false
      //     },
      //     paging: {
    //         pagerTotal : false,
    //         // hidePageList : false,
    //         pagerSelect : false
      //     },
          
      //     columnMapping : [
    //         //{   key : 'brandId',          hidden: true },
    //         //{   width : '30px',            selectorColumn : true   },
    //         {   selectorColumn : true ,   title : '선택',          width : '46px', align : 'center' },
    //         {   key : 'brandName',     title : '모델상세/배기량/원통기형식',      width : '370px', align : 'center'  },
    //         {   key : 'brandEngName',     title : '차종코드',      width : '150px', align : 'center'  },
    //         {   key : 'brandId',     title : '국내사양',      width : '100px', align : 'center'  },
    //         {   key : 'sailDiscountRate',     title : '빈도',          width : '100px', align : 'center'  }
      //     ]
        //}
      }
    }
  },
  created() {
      //alert("created");
  },
  mounted () {
      //alert("mounted");
  },
  methods : {
    beforeOpen(e) {
      //변수 초기화
      this.grid_options.general.search = '';
      this.carName = '';
      this.grid_options.general.params.commonParam = '';
      this.grid_options.general.params.ifCondition = 'carId';
    },
    opened(e) {
      //팝업창 닫기 관련 css 컨트롤(공통)
      $("#div_carModelNameSrch").parent().css('overflow', 'visible');
      //팝업창 스크롤바 css 컨트롤(공통)
      $("#scroll_area").mCustomScrollbar( {
        theme: "dark-thick",
        scrollInertia: 500
      });
    },
    close() {
      this.$modal.hide('carModelNameSrchPopup');
    },
    selectTabCode(tabName) {
      //탭 클릭할 경우 탭코드 초기화
      this.selectedCode = '';
      this.grid_options.general.params.commonParam = '';
      this.grid_options.general.params.ifCondition = '';

      //탭 클릭할 경우 검색된 자동차모델명 초기화
      this.carName = '';
      //탭클릭시 탭 코드 삽입
      this.selectedCode = tabName;
      
      //탭 클릭시 조회 구분 코드 삽입
      this.grid_options.general.params.ifCondition = this.selectedCode.ifCondition;  
    },
    searchCarModelName() {

      //alert("차량모델명 조회 파라미터::" + JSON.stringify(this.grid_options.general.params));
      //this.grid_options.general.PageInfo.current = 1;
      //alert("그리드검색세팅::" + JSON.stringify(this.grid_options.general.params));
      //GridModule.searchData(this.grid_options);
      //this.carName = 'BMW 컨버터블 (하드코딩)';

      Vue.httpClient
      .get('/carinfo/vin', {})
      .then((result) => {
        if ( result.data.result ) {
          alert(JSON.stringify(result.data.result));
        }
      })


    },
    sendCarModelName(e) {
      this.$emit('car-model-name-srch-popup-complete', this.carName);
      this.$modal.hide('carModelNameSrchPopup');
    }

  }

}
</script>


// WEBPACK FOOTER //
// src/views/common/CarModelNameSrchPopup.vue